import { crudReducer } from "./dataHelper";

const initialState = () => ({
  project_memberships: []
});

export default crudReducer("project_membership", initialState);
